import { ApiError } from "./errors";

/**
 * What a sponsor is told when a roster call fails.
 *
 * 🔑 A sponsor is an organisation's staff member, not the provider. A refusal
 * it cannot fix itself (no organisation link, organisation not on this
 * hotspot) must name who can -- otherwise a grey Upload button reads as a
 * broken screen, which is what happened on test.ankhos.io on 2026-09-13.
 *
 * Keyed on radcustomer's own messages (app/handler/roster.go
 * rosterOrganisation and RosterBatchUpload). An unrecognised refusal still
 * shows the server's words rather than a guess.
 */
export function rosterRefusal(e: unknown, namespace: string): string {
  if (!(e instanceof ApiError)) return e instanceof Error ? e.message : String(e);
  const said = e.message;

  if (e.kind === "unauthenticated") return "Your sign-in has expired. Sign out and sign in again.";
  if (e.kind === "forbidden") {
    if (/not linked to an organisation/i.test(said)) {
      return "Your sign-in is not linked to an organisation yet, so there is no roster to show. Ask your service provider to link it.";
    }
    if (/suspended/i.test(said)) {
      return "Your organisation is suspended on this hotspot. Ask your service provider.";
    }
    return `Refused: ${said}. Your sign-in may not manage this roster.`;
  }
  if (e.kind === "not-found") {
    if (/organisation not found on this namespace/i.test(said)) {
      return `Your organisation is not set up on this hotspot (${namespace}). Ask your service provider.`;
    }
    return `The roster service is not available here yet (${said}).`;
  }
  return said;
}
